import { render, staticRenderFns } from "./ListaArrematantes.vue?vue&type=template&id=56a52ae9&"
import script from "./ListaArrematantes.vue?vue&type=script&lang=js&"
export * from "./ListaArrematantes.vue?vue&type=script&lang=js&"
import style0 from "../assets/default.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports